import { useQuery } from '@tanstack/react-query'

export const useNonLocalizableFields = (assetID, cycleID) => {
  const standardKey = [`field-values`, `?assetID=${assetID}`, `&cycleID=${cycleID}`, `&isStandard=true`]
  const commonKey = [`field-values`, `?assetID=${assetID}`, `&cycleID=${cycleID}`]
  const { data: standardFields, isLoading: isStandardLoading } = useQuery(standardKey)
  const { data: commonFields, isLoading: isCommonLoading } = useQuery(commonKey)

  const fields = []
  const seen = new Set()
  for (const [group, cacheKey] of [
    [standardFields, standardKey],
    [commonFields, commonKey],
  ]) {
    for (const field of group ?? []) {
      if (seen.has(field.id)) continue
      seen.add(field.id)
      fields.push({ field, cacheKey })
    }
  }

  return {
    fields,
    cacheKeys: [standardKey, commonKey],
    isLoading: isStandardLoading || isCommonLoading,
  }
}
